import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const generateText = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/generate`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const improveText = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/improve`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const makeTextFormal = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/formal`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const fixGrammarAndSpelling = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/fix`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const makeTextConcise = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/concise`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const makeTextLonger = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/longer`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const changeTone = async (text: string, tone: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/tone`, { text, tone, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};

export const regenerateText = async (text: string, customAccessToken?: string, isReview?: boolean) => {
  return apiInstance.post(`${ApiRoutes.Service}/regenerate`, { text, ...(isReview && { isReview }) }, customAccessToken ? {
    headers: {
      Authorization: `Bearer ${customAccessToken}`
    }
  } : undefined);
};
